export default {
  id: "RegisterOnPosterModal",
  code: "CN",
  text: {
  'Register': '报名',
  'Deadline':  '报名结束日期',
  'Deadline: N/A': '报名结束日期: 无限期',
  'Applicant Information': '报名人资料',
  'Last Name': '姓',
  'First Name': '名',
  'Date Of Birth': '生日',
  'Applicant\'s Email': '报名人邮件',
  'Applicant\'s Phone': '报名人电话',
  'Contact Person Information': '联系人资料',
  'Submit': '提交',
  "Next": '下一步',

  'Contact Info': '联系人资料',
  'Full Name': '姓名',
  'Email': '邮件',
  'Phone': '电话',
  'Submit': '提交',
  'Submitting...': '正在提交...',
  'This field must not be empty.': '此项不能为空',
  'A valid phone number is required.': '请输入正确的电话号码',
  'A valid email is required.': '请输入正确的邮件地址',

  'Are you sure you want to remove the applicant?': '确认删除此报名人？',

  'No more space left.': '报名名额已满',
  'Contact info is missing.': '请填写联系人信息',
  'Registration Failed': '注册失败',

  'Registration is closed': '报名已结束',

  }
}



// WEBPACK FOOTER //
// ./src/shared/RegisterClassModal/locale.js